import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postChannelCheck,
  type PostChannelCheckParams,
  type PostChannelCheckResponse,
} from '@services/TasksService';

export type UsePostChannelCheckParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostChannelCheckResponse,
    unknown,
    string,
    PostChannelCheckParams,
    PostChannelCheckResponse
  >;
};

export const postChannelCheckMutationKey = 'post-channel-check';

export const usePostChannelCheck = ({
  mutationOptions,
}: UsePostChannelCheckParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostChannelCheckResponse,
    unknown,
    string,
    PostChannelCheckParams
  >(
    postChannelCheckMutationKey,
    (_url, { arg }) => postChannelCheck(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
